import React, { useState } from "react";
import { Alert, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Fab, TextField, Tooltip, Typography } from "@mui/material";
import RateReviewRoundedIcon from "@mui/icons-material/RateReviewRounded";
import { getToken } from "../services/auth";

export default function FeedbackWidget() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const submit = async () => {
    const feedback = message.trim();
    if (!feedback || feedback.length > 300) return setError("Feedback must be between 1 and 300 characters.");
    setSaving(true); setError("");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/feedback`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
        body: JSON.stringify({ message: feedback }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Unable to submit feedback");
      setMessage(""); setSuccess(data.message); window.setTimeout(() => { setOpen(false); setSuccess(""); }, 1400);
    } catch (submitError) { setError(submitError.message); }
    finally { setSaving(false); }
  };

  return <>
    <Tooltip title="Share feedback" placement="left">
      <Fab size="medium" color="secondary" aria-label="Share feedback" onClick={() => setOpen(true)} sx={{ position: "fixed", right: 22, bottom: 22, zIndex: 1250, color: "white", boxShadow: "0 10px 28px rgba(4,99,128,.3)" }}>
        <RateReviewRoundedIcon fontSize="small" />
      </Fab>
    </Tooltip>
    <Dialog open={open} onClose={() => !saving && setOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 800 }}>Share your feedback</DialogTitle>
      <DialogContent>
        <Typography color="text.secondary" sx={{ mb: 2 }}>Tell us what would make Demand Supply better. Feedback is retained for 30 days.</Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
        <TextField autoFocus multiline minRows={5} fullWidth label="Feedback" value={message} onChange={(event) => setMessage(event.target.value.slice(0, 300))} inputProps={{ maxLength: 300 }} helperText={`${message.length}/300 characters`} />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}><Button onClick={() => setOpen(false)} disabled={saving}>Cancel</Button><Button variant="contained" onClick={submit} disabled={saving || !message.trim()}>{saving ? <Box sx={{ display: "flex", gap: 1 }}><CircularProgress size={20} color="inherit" />Submitting</Box> : "Submit feedback"}</Button></DialogActions>
    </Dialog>
  </>;
}
